import React, { useState, useEffect } from 'react';
import {
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    Box,
    Divider,
    Avatar,
    Typography,
    Tooltip
} from '@mui/material';
import {
    Dashboard, Devices, People, ExpandLess, ExpandMore, Report, Room
} from '@mui/icons-material';
import { NavLink } from 'react-router-dom';
import { Logout } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button
} from '@mui/material';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import PasswordResetDialog from './PasswordResetDialog';

const drawerWidth = 240;

const Sidebar = () => {
    const [openVendor, setOpenVendor] = useState(false);
    const [pwDialogOpen, setPwDialogOpen] = useState(false);

    const handleVendorClick = () => {
        setOpenVendor(!openVendor);
    };

    const [imageUrl, setImageUrl] = useState('/t.jpg');

    const navItemStyles = (isActive) => {
        const baseStyles = {
            color: isActive ? '#1e2a38' : '#ecf0f1',
            backgroundColor: isActive ? '#E0E0E0' : 'transparent',
            minHeight: 30,
            px: 2,
            borderRadius: 6,
            mb: 1,
        };

        if (!isActive) {
            baseStyles['&:hover'] = {
                backgroundColor: '#bdc3c7',
                color: '#1e2a38',
                '& .MuiListItemIcon-root': {
                    color: '#1e2a38',
                },
            };
        }
        if (isActive) {
            baseStyles['&:hover'] = {
                backgroundColor: '#ecf0f1',
                color: '#1e2a38',
                '& .MuiListItemIcon-root': {
                    color: '#1e2a38',
                },
            };
        }

        return baseStyles;
    };

    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

    const handleLogoutClick = () => {
        setOpenLogoutDialog(true);
    };

    const handleConfirmLogout = () => {
        logout();
        setOpenLogoutDialog(false);
        navigate('/login');
    };

    const handleCancelLogout = () => {
        setOpenLogoutDialog(false);
    };

    const getImage = async (userId, setImageUrl) => {
        try {
            const response = await fetch(`/users/profile-image/${userId}`, {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error('Failed to fetch profile image');
            }

            const blob = await response.blob();
            const imageObjectUrl = URL.createObjectURL(blob);
            setImageUrl(imageObjectUrl);
        } catch (error) {
            console.error('Error fetching image:', error);
            // You can fallback to a default image here
            setImageUrl('/default-profile.png'); // fallback
        }
    };

    useEffect(() => {
        if (user?._id) {
            getImage(user._id, setImageUrl);
        }
    }, [user]);

    return (
        <Drawer
            variant="permanent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    background: 'linear-gradient(180deg, #01183b 0%, #2c3e55 100%)',
                    color: '#fff',
                    boxSizing: 'border-box',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 2,
                    px: 1,
                    borderBottom: '1px solid rgba(255,255,255,0.2)'
                }}
            >
                <Box component="img" src="/favicon.ico" alt="Logo" sx={{ width: 30, height: 30, mr: 1 }} />
                <Typography variant="h6" sx={{ color: 'white', fontWeight: 600, fontSize: '16px' }}>
                    MoChaPo Admin Hub
                </Typography>
            </Box>

            <Box sx={{ overflow: 'auto' }}>
                {/* Profile Section */}
                {/* <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2 }}>
                    <Avatar
                        src="/t.jpg"
                        alt="John Snow"
                        sx={{ width: 80, height: 80, borderRadius: 2, mb: 1 }}
                    />
                    <Typography variant="body1" sx={{ color: 'white', fontWeight: 500 }}>
                        John Snow
                    </Typography>
                </Box> */}

                {/* Navigation List */}
                <List>
                    {/* <NavLink to="/" style={{ textDecoration: 'none' }}>
                        {({ isActive }) => (
                            <ListItemButton dense sx={navItemStyles(isActive)}>
                                <ListItemIcon sx={{ color: isActive ? '#1e2a38' : 'white' }}>
                                    <Dashboard />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Dashboard"
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }}
                                />
                            </ListItemButton>
                        )}
                    </NavLink> */}

                    <NavLink to="/devices" style={{ textDecoration: 'none' }}>
                        {({ isActive }) => (
                            <ListItemButton dense sx={navItemStyles(isActive)}>
                                <ListItemIcon sx={{ color: isActive ? '#1e2a38' : 'white' }}>
                                    <Devices />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Devices"
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }}
                                />
                            </ListItemButton>
                        )}
                    </NavLink>
                    {/* 
                    <ListItemButton dense onClick={handleVendorClick} sx={{ color: 'white', minHeight: 30, mb: 1 }}>
                        <ListItemIcon sx={{ color: 'white' }}>
                            <People />
                        </ListItemIcon>
                        <ListItemText
                            primary="Vendor"
                            primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }}
                        />
                        {openVendor ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse in={openVendor} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <NavLink to="/vendor/master" style={{ textDecoration: 'none' }}>
                                {({ isActive }) => (
                                    <ListItemButton
                                        dense
                                        sx={{
                                            pl: 4,
                                            pr: 2,
                                            ...navItemStyles(isActive),
                                        }}
                                    >
                                        <ListItemText
                                            primary="Vendor Master"
                                            primaryTypographyProps={{
                                                fontSize: 12,
                                                fontWeight: 700,
                                                textAlign: 'left',
                                            }}
                                        />
                                    </ListItemButton>
                                )}
                            </NavLink>

                            <NavLink to="/vendor/device-mapping" style={{ textDecoration: 'none' }}>
                                {({ isActive }) => (
                                    <ListItemButton
                                        dense
                                        sx={{
                                            pl: 4,
                                            pr: 2,
                                            ...navItemStyles(isActive),
                                        }}
                                    >
                                        <ListItemText
                                            primary="Device Vendor Mapping"
                                            primaryTypographyProps={{
                                                fontSize: 12,
                                                fontWeight: 700,
                                                textAlign: 'left',
                                            }}
                                        />
                                    </ListItemButton>
                                )}
                            </NavLink>

                            <NavLink to="/vendor/payment" style={{ textDecoration: 'none' }}>
                                {({ isActive }) => (
                                    <ListItemButton
                                        dense
                                        sx={{
                                            pl: 4,
                                            pr: 2,
                                            ...navItemStyles(isActive),
                                        }}
                                    >
                                        <ListItemText
                                            primary="Payment"
                                            primaryTypographyProps={{
                                                fontSize: 12,
                                                fontWeight: 700,
                                                textAlign: 'left',
                                            }}
                                        />
                                    </ListItemButton>
                                )}
                            </NavLink>
                        </List>
                    </Collapse> */}

                    {user?.role !== 'vendor' && (
                        <>
                            <ListItemButton dense onClick={handleVendorClick} sx={{ color: 'white', minHeight: 30, mb: 1 }}>
                                <ListItemIcon sx={{ color: 'white' }}>
                                    <People />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Vendor"
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }}
                                />
                                {openVendor ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>

                            <Collapse in={openVendor} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <NavLink to="/vendor/master" style={{ textDecoration: 'none' }}>
                                        {({ isActive }) => (
                                            <ListItemButton
                                                dense
                                                sx={{
                                                    pl: 4,
                                                    pr: 2,
                                                    ...navItemStyles(isActive),
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Vendor Master"
                                                    primaryTypographyProps={{ fontSize: 12, fontWeight: 700, textAlign: 'left' }}
                                                />
                                            </ListItemButton>
                                        )}
                                    </NavLink>
                                    <NavLink to="/vendor/device-mapping" style={{ textDecoration: 'none' }}>
                                        {({ isActive }) => (
                                            <ListItemButton
                                                dense
                                                sx={{ pl: 4, pr: 2, ...navItemStyles(isActive) }}
                                            >
                                                <ListItemText
                                                    primary="Device Vendor Mapping"
                                                    primaryTypographyProps={{ fontSize: 12, fontWeight: 700, textAlign: 'left' }}
                                                />
                                            </ListItemButton>
                                        )}
                                    </NavLink>
                                    {/* <NavLink to="/vendor/payment" style={{ textDecoration: 'none' }}>
                                        {({ isActive }) => (
                                            <ListItemButton
                                                dense
                                                sx={{ pl: 4, pr: 2, ...navItemStyles(isActive) }}
                                            >
                                                <ListItemText
                                                    primary="Payment"
                                                    primaryTypographyProps={{ fontSize: 12, fontWeight: 700, textAlign: 'left' }}
                                                />
                                            </ListItemButton>
                                        )}
                                    </NavLink> */}
                                </List>
                            </Collapse>
                        </>
                    )}

                    <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.2)', mb: 0.5 }} />

                    {user?.role !== 'vendor' && (
                        <>
                            <NavLink to="/user" style={{ textDecoration: 'none' }}>
                                {({ isActive }) => (
                                    <ListItemButton dense sx={navItemStyles(isActive)}>
                                        <ListItemIcon sx={{ color: isActive ? '#1e2a38' : 'white' }}>
                                            <People />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="User"
                                            primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }}
                                        />
                                    </ListItemButton>
                                )}
                            </NavLink>

                            <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.2)', mb: 0.5 }} />
                        </>
                    )}

                    <NavLink to="/reports" style={{ textDecoration: 'none' }}>
                        {({ isActive }) => (
                            <ListItemButton dense sx={navItemStyles(isActive)}>
                                <ListItemIcon sx={{ color: isActive ? '#1e2a38' : 'white' }}>
                                    <Report />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Reports"
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }}
                                />
                            </ListItemButton>
                        )}
                    </NavLink>

                    <NavLink to="/device-locator" style={{ textDecoration: 'none' }}>
                        {({ isActive }) => (
                            <ListItemButton dense sx={navItemStyles(isActive)}>
                                <ListItemIcon sx={{ color: isActive ? '#1e2a38' : 'white' }}>
                                    <Room />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Device Locator"
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }}
                                />
                            </ListItemButton>
                        )}
                    </NavLink>

                    <NavLink to="/ticket-management" style={{ textDecoration: 'none' }}>
                        {({ isActive }) => (
                            <ListItemButton dense sx={navItemStyles(isActive)}>
                                <ListItemIcon sx={{ color: isActive ? '#1e2a38' : 'white' }}>
                                    <BugReportOutlinedIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Ticket Management"
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: 700 }}
                                />
                            </ListItemButton>
                        )}
                    </NavLink>
                </List>

            </Box>

            <Box
                sx={{
                    mt: 'auto',
                    p: 2,
                    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Tooltip title="Profile" arrow>
                    <Box
                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        onClick={() => setPwDialogOpen(true)}
                    >
                        <Avatar src={imageUrl} sx={{ width: 32, height: 32, mr: 1 }} />
                        <Typography variant="body2" sx={{ color: 'white', fontWeight: 500 }}>
                            {user?.user_name || 'Admin'}
                        </Typography>
                    </Box>
                </Tooltip>


                <Tooltip title="Logout" arrow>
                    <Logout onClick={handleLogoutClick} sx={{ cursor: 'pointer', color: 'white' }} />
                </Tooltip>
            </Box>

            <PasswordResetDialog
                open={pwDialogOpen}
                onClose={() => setPwDialogOpen(false)}
            />



            <Dialog
                open={openLogoutDialog}
                onClose={handleCancelLogout}
                aria-labelledby="logout-dialog-title"
                aria-describedby="logout-dialog-description"
            >
                {/* Header with background color */}
                <Box sx={{
                    backgroundColor: '#1e2a38',
                    color: 'white',
                }}>
                    <DialogTitle id="logout-dialog-title" sx={{ fontWeight: 'bold', p: 1.5 }}>
                        Confirm Logout
                    </DialogTitle>
                </Box>

                {/* Separator */}
                <Divider />

                {/* Content */}
                <DialogContent sx={{}}>
                    <DialogContentText id="logout-dialog-description">
                        Are you sure you want to log out?
                    </DialogContentText>
                </DialogContent>

                {/* Footer with background color */}
                <Box sx={{ backgroundColor: '#e3eaf2' }}>
                    <DialogActions>
                        <Button onClick={handleCancelLogout} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleConfirmLogout} color="primary">
                            Logout
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>



        </Drawer>
    );
};

export default Sidebar;
